import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";
const dummyData = {
  name: "Tan Leatherette Weekender Duffle",
  category: "Fashion",
  cost: 150,
  rating: 4,
  image:
    "https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
  _id: "PmInA797xJhMIPti",
};

const ProductCard = ({ productProp, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia
        component="img"
        alt={productProp.name}
        // height="140"
        src={productProp.image}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" color="primary">
          {productProp.name}
        </Typography>
        <Typography variant="subtitle2" color="text-secondary">
          {productProp.category}
        </Typography>
        <Typography variant="subtitle2" color="text-secondary">
          ${productProp.cost}
        </Typography>
      </CardContent>
      <Rating
        name="read-only"
        precision={0.5}
        value={productProp.rating}
        readOnly
      ></Rating>
      <Button onClick={handleAddToCart} size="small" className="card-button" role="button" variant="contained">
        ADD TO CART
      </Button>
    </Card>
  );
};

export default ProductCard;
